import { render, staticRenderFns } from "./terraform-statefile-aws.vue?vue&type=template&id=1eb84fe7&scoped=true&"
import script from "./terraform-statefile-aws.vue?vue&type=script&lang=js&"
export * from "./terraform-statefile-aws.vue?vue&type=script&lang=js&"
import style0 from "./terraform-statefile-aws.vue?vue&type=style&index=0&id=1eb84fe7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb84fe7",
  null
  
)

export default component.exports